import { ReactElement, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ISchemaNode, ISelectedNode, IState } from "../../../types";
import { SystemContext } from "../../../context/systemContext";
import ChildComponent from "./childComponent";

interface IAlarmsDashboardProps {
  parentSize: {
    width: number;
    height: number;
  };
}

const GeneralDashboard = ({ parentSize }: IAlarmsDashboardProps): ReactElement => {
  const selectedNode = useSelector<IState, ISelectedNode>(state => state.selectedNode);
  const [ currentNode, setCurrentNode ] = useState<ISchemaNode | null>(null);
  const { schema } = useContext(SystemContext);


  useEffect(() => {
    if (selectedNode && schema) {

      const findNode = (parent: ISchemaNode): ISchemaNode | null=> {

        if(parent.type === selectedNode.type && parent.nodeID === selectedNode.nodeID) {
          return parent;
        }

        if (parent.children) {
          for (const item of parent.children) {
            const node = findNode(item);
            if (node) {
              return node;
            }
          }
        }

        return null;
      };

      for (const item of schema) {
        const node = findNode(item);
        if (node) {
          setCurrentNode(node);

          return;
        }
      }
    }
  }, [selectedNode, schema]);


  return (
    <div className="display-flex-row flex-wrap justify-content-center" style={{ ...parentSize }}>
      { currentNode && currentNode.children && currentNode.children.map((child, index) => {
        return(
          <ChildComponent key={`general-gantt-${index}`} node={child} />
        );
      })
      }
    </div>
  );
};

export default GeneralDashboard;
